import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { addSelectedDish } from 'features/food/foodSlice'
import useModalClose from 'hooks/useModalClose'
import { days } from 'pages/Employees/employeesData'
import { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex, ModalScrollContainer, ThinSeparator } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { dietaryPreferences } from '../foodData'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { AddCircle } from 'assets/icons/AddCircle'

export const AddSelectedDishModal = ({ closeModal, data }: { closeModal: any, data: ISelectedDish[] }) => {
    const [state, setState] = useState<ISelectedDish[]>(data || [{
        id: new Date().getMilliseconds(),
        day: null,
        dietaryPreference: null,
        mealType: null,
        dish: null,
        supplier: null
    }])
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)


    const handleSave = async () => {
        const resp = await (dispatch(addSelectedDish(state)))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleSelect = (value: ISelectValue, name: string, id: number) => {
        const newState = state.map((item) => {
            if (item.id === id) {
                return { ...item, [name]: value }
            }
            return item
        })
        setState(newState)
    }

    const parse = (data: any) => {
        return data.data.map((item) => ({ label: item.name, value: item.id }))
    }

    const handleAddDish = () => {
        setState([...state, {
            id: new Date().getMilliseconds(),
            day: null,
            dietaryPreference: null,
            mealType: null,
            dish: null,
            supplier: null
        }])
    }

    const handleRemoveDish = (id: number) => {
        const newState = state.filter(d => d.id !== id)
        setState(newState)
    }

    const disabled = useMemo(() => {
        return state.some(d => !d.day?.value || !d.dietaryPreference?.value || !d.mealType?.value || !d.dish?.value || !d.supplier?.value)
    }, [state])

    return <Modal black>
        <Flex width='100%' between >
            <TitleText weight='bold' >Add Selected Dish</TitleText>
            <CursorPointer onClick={closeModal} >
                <CloseIcon />
            </CursorPointer>
        </Flex>
        <ModalScrollContainer style={{ margin: '1rem 0' }} >
            <Flex column between height='100%' center >
                {state.map(d => <Flex column gap='0.5rem' key={d.id} >
                    <Flex gap='1rem' mt='16'>
                        <HonestSelectInput labelText='Day' onChange={(v: ISelectValue, n) => handleSelect(v, n, d.id)} name='day' options={days} required defaultValue={d.day?.value} />
                        <HonestSelectInput labelText='Dietary Preference' onChange={(v: ISelectValue, n) => handleSelect(v, n, d.id)} name='dietaryPreference' options={dietaryPreferences} required defaultValue={d.dietaryPreference?.value} />
                        <HonestSelectAsyncInput
                            name='mealType'
                            labelText='Meal Type'
                            onChange={(v, n) => handleSelect(v, n, d.id)}
                            placeholder='Select Meal Type'
                            link='food/management/meal/type'
                            parserFunction={parse}
                            required
                            defaultValue={d.mealType?.label}
                        />
                        <HonestSelectAsyncInput
                            name='dish'
                            labelText='Dish'
                            onChange={(v, n) => handleSelect(v, n, d.id)}
                            placeholder='Select Dish'
                            link='food/management/dish'
                            parserFunction={parse}
                            required
                            defaultValue={d.dish?.label}

                        />
                        <HonestSelectAsyncInput
                            name='supplier'
                            labelText='Supplier'
                            onChange={(v, n) => handleSelect(v, n, d.id)}
                            placeholder='Select Supplier'
                            link='food/management/meal/supplier'
                            parserFunction={parse}
                            required
                            defaultValue={d.supplier?.label}

                        />
                        {state.length > 2 && <CursorPointer onClick={() => handleRemoveDish(d.id)} >
                            <CloseIcon />
                        </CursorPointer>}
                    </Flex>
                    <ThinSeparator margin='0' />
                    {(state.length === 1 || (state.findIndex(ds => ds.id == d.id) == (state.length) - 1)) && state.length !== 7 && <Flex width='100%' justend >
                        <CursorPointer
                            start='true'
                            onClick={handleAddDish}
                            ml='1rem'
                            mt='5px'
                        >
                            <AddCircle />
                        </CursorPointer>
                    </Flex>}
                </Flex>)}

            </Flex>
        </ModalScrollContainer>
        <Flex width='100%' center justcenter>
            <Button variant='primary' disabled={disabled} onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface ISelectedDish {
    id: number
    day: ISelectValue
    dietaryPreference: ISelectValue
    mealType: ISelectValue
    dish: ISelectValue
    supplier: ISelectValue
}